import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '../../ThemeContext';

const CustomContainer = ({ children, sx = {}, containerWidth = '80%' }) => {
  const { themeMode, currentTheme } = useTheme();

  const defaultStyles = {
    width: containerWidth,
    minHeight: '82vh',
    maxHeight: '82vh',
    backgroundColor: currentTheme.callhistory.mainBackground,
    // Adjust the left/right padding here for more or less space on the sides
    padding: { xs: '1rem 0.5rem', sm: '1.5rem 2rem', md: '2rem 3rem' },
    overflow: 'auto',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    margin: '0 auto',
    // Custom thin scrollbar styles
    scrollbarWidth: 'thin', // Firefox
    scrollbarColor: 'rgba(120,120,120,0.25) transparent', // Firefox
    '&::-webkit-scrollbar': {
      width: 6,
      height: 6,
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(120,120,120,0.25)',
      borderRadius: 4,
    },
    '&::-webkit-scrollbar-corner': {
      background: 'transparent',
    },
    '& > *': {
      width: '100%',
      minHeight: 0, // Allow flex children to shrink
      overflow: 'visible',
      display: 'flex',
      flexDirection: 'column',
      flex: 1, // Allow flex children to grow/shrink as needed
      '& > *': {
        width: '100%',
        overflow: 'auto',
        '&::-webkit-scrollbar': {
          width: '8px',
          height: '8px',
        },
        '&::-webkit-scrollbar-track': {
          background: themeMode === 'dark' ? '#2d2d2d' : '#f1f1f1',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: themeMode === 'dark' ? '#555' : '#888',
          borderRadius: '4px',
          '&:hover': {
            background: themeMode === 'dark' ? '#666' : '#999',
          },
        },
        '&:not(:hover)::-webkit-scrollbar-thumb': {
          background: 'transparent',
        },
      }
    }
  };

  return (
    <Box
      sx={{
        ...defaultStyles,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default CustomContainer; 